export class EnvironmentConfig {
  environment: unknown;
}
